import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// const SizeStyle = Quill.import('attributors/style/size')
// Quill.register(SizeStyle, true)

const StyleAlign = Quill.import('attributors/style/align')
Quill.register(StyleAlign, true)
export default Quill
